<template>
  <div>
    <v-row>
      <v-col cols="12" md="3" @click="showDetails('companies')" style="cursor: pointer;">
        <stat title="شرکت فعال" :number="stats.active_companies.count"/>
      </v-col>
      <!-- <v-col cols="12" md="3" @click="showDetails('users')" style="cursor: pointer;">
        <stat title="کاربر فعال" :number="stats.active_users.count" />
      </v-col> -->
      <v-col cols="12" md="3" @click="showDetails('expiring-subscriptions')" style="cursor: pointer;">
        <stat title="شرکت های درحال انقضا" :number="stats.expiring_packages.count" />
      </v-col>
      <v-col cols="12" md="3" @click="showDetails('churned-companies')" style="cursor: pointer;">
        <stat title="شرکت های خروجی" :number="stats.churned_companies.count" />
      </v-col>
      <v-col cols="12" md="3" @click="showDetails('today-logins')" style="cursor: pointer;">
        <stat title="ورود های امروز" :number="todayLogins.count" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <chart
          title="کاربران جدید"
          subtitle="نمودار تعداد کاربران جدید بر اساس بازه زمانی انتخابی"
          url="sobhanAdmin/user-join-stats/"
        />
      </v-col>
      <v-col cols="12" md="6">
        <sales-chart />
      </v-col>

      <v-col cols="12" md="6">
        <chart title="سند های روزانه" subtitle="نمودار تعداد سند های ثبت شده روزانه" url="sobhanAdmin/sanad-stats/" />
      </v-col>

      <v-col cols="12" md="6">
        <chart
          title="لاگین‌های روزانه"
          subtitle="نمودار تعداد دفعات ورود کاربران (قدیم و جدید) در هر روز"
          url="sobhanAdmin/daily-login-stats/"
        />
      </v-col>
      <v-col cols="12" md="6">
        <grouped-bar-chart
          title="لاگین‌های روزانه به تفکیک بازه زمانی"
          subtitle="هفته اخیر — صبح / عصر / شب"
          url="sobhanAdmin/weekly-login-by-shift/"
          chart-id="login-shift-chart"
          :datasets="[
            { key: 'morning', label: 'صبح (۹-۱۷)',  color: '#FFC700' },
            { key: 'evening', label: 'عصر (۱۷-۱)',  color: '#50CC89' },
            { key: 'night',   label: 'شب (۱-۹)',    color: '#43CED7' },
          ]"
        />
      </v-col>

    </v-row>
    
    <v-dialog v-model="dialogVisible" max-width="1200px">
      <stats-dialog
        v-if="currentType !== 'today-logins'"
        :type="currentType"
        :data="stats"
        @close="dialogVisible = false"
      />
      <today-logins-dialog
        v-else
        :data="todayLogins"
        @close="dialogVisible = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import Chart from "@/components/widgets/Chart.vue";
import Stat from "@/components/widgets/Stat.vue";
import SalesChart from "@/components/widgets/SalesChart.vue";
import MDatatable from "@/components/m-datatable/MDatatable.vue";
import StatsDialog from "@/components/widgets/StatsDialog.vue";
import TodayLoginsDialog from "@/components/widgets/TodayLoginsDialog.vue";
import GroupedBarChart from "@/components/widgets/GroupedBarChart.vue";

export default {
  components: {
    Chart,
    Stat,
    SalesChart,
    MDatatable,
    StatsDialog,
    TodayLoginsDialog,
    GroupedBarChart,
  },
  data() {
    return {
      stats: {
        active_companies: { count: 0, details: [] },
        active_users: { count: 0, details: [] },
        expiring_packages: { count: 0, details: [] },
        churned_companies: { count: 0, details: [] },
      },
      todayLogins: {
        count: 0,
        users: [],
      },
      dialogVisible: false,
      currentType: null,
    };
  },
  methods: {
    showDetails(type) {
      this.currentType = type;
      this.dialogVisible = true;
    },
    fetchData() {
      this.request({
        url: this.endpoint("sobhanAdmin/active-stats/"),
        success: (data) => {
          this.stats = data;
        },
      });
    },
    fetchTodayLogins() {
      this.request({
        url: this.endpoint("sobhanAdmin/today-logins/"),
        success: (data) => {
          this.todayLogins = data;
        },
      });
    },
  },
  mounted() {
    this.fetchData();
    this.fetchTodayLogins();
  },
};
</script>

<style scoped></style>